import createDuck from '../../../lib/ducks/remoteDuck'
import EditorialApiHandler from '../../../lib/api/editorial'

export default createDuck({
  namespace: 'content',
  store: 'editorialSlides',
  fetchCallback: EditorialApiHandler.getSlides,
})
